export { default } from './src/ShowMoreText';
